/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from "react";
import { GrClose } from "react-icons/gr";
import { GiHamburgerMenu } from "react-icons/gi";
import "./styles.scss";
import { Link } from "react-router-dom";
import { URL_PATHS } from "../../routes";

const logoSrc = require("../../assets/img/logo-long.svg").default;

interface HeaderProps {
    isBurgerOpen: boolean;
    onClickBurger: () => void;
    isBurgerHidden?: boolean;
}

const Header = (props: HeaderProps) => {
    return (
        <div className="header">
            <h1>
                <Link to={URL_PATHS.myPage()}>
                    <img src={logoSrc} />
                </Link>
            </h1>
            {!props.isBurgerHidden && (
                <div className="burger" onClick={props.onClickBurger}>
                    {props.isBurgerOpen && <GrClose />}
                    {!props.isBurgerOpen && <GiHamburgerMenu />}
                </div>
            )}
        </div>
    );
};

export default Header;
